import { Injectable } from '@angular/core';
import { MainBanner } from '@core/models/piramide/mainBanner';
import { Brand } from '@core/models/piramide/Brand';
import { Subcategory } from '@core/models/piramide/Subcategory';
import { SubcategoryGrouper } from '@core/models/piramide/SubcategoryGrouper';
import { PiramidalCacheService } from './piramdialCache.service';
import { Product } from '@core/models/piramide/Product';
import { ProductDetails } from '@core/models/piramide/ProductDetails';
import { FetaureGrouper } from '@core/models/piramide/FeatureGrouper';
import { FindAplications } from '@core/models/piramide/Aplications';
import { EquipmentResume } from '@core/models/piramide/EqipmentResume';
import { Faqs } from '@core/models/piramide/Faqs';
import { Questions } from '@core/models/piramide/Questions';
import { SubcategoryBanner } from '@core/models/piramide/SubcategoryBanner';
import { FeaturesProduct } from '@core/models/piramide/FeaturesProduct';
import { EspacioIntercalado } from '@core/models/piramide/EspacioIntercalado';
import { EspacioLateral } from '@core/models/piramide/EspacioLateral';
import { EspacioSuperior } from '@core/models/piramide/EspacioSuperior';
import { Liquidation } from '@core/models/piramide/Liquidation';

@Injectable({
  providedIn: 'root',
})
export class PiramidalService {
  public brands = this.cacheService.add(Brand);
  public findAplications = this.cacheService.add(FindAplications);
  public equipmentResume = this.cacheService.add(EquipmentResume);
  public mainBanners = this.cacheService.add(MainBanner);
  public espacioSuperior = this.cacheService.add(EspacioSuperior);
  public espacioLateral = this.cacheService.add(EspacioLateral);
  public espacioIntercalado = this.cacheService.add<EspacioIntercalado>(EspacioIntercalado);
  public subcategories = this.cacheService.add(Subcategory);
  public subcategoryBanner = this.cacheService.add(SubcategoryBanner);
  public subcategoriesGroupers = this.cacheService.add(SubcategoryGrouper);
  public products = this.cacheService.add(Product);
  public ProductDetails = this.cacheService.add(ProductDetails);
  public FetaureGrouper = this.cacheService.add(FetaureGrouper);
  public featuresProduct = this.cacheService.add(FeaturesProduct);
  public faqs = this.cacheService.add(Faqs);
  public questions = this.cacheService.add(Questions);

  constructor(private cacheService: PiramidalCacheService) {}
}
